import {
  CircleGeometry,
  DoubleSide,
  Mesh,
  MeshBasicMaterial,
  RingGeometry,
  Vector3,
} from 'three';

const _z = new Vector3(0, 0, 1);

/**
 * Abstract ground disc + bright horizon ring for surface POV.
 * Kept modest so it frames the lower third without filling the sky.
 */
export function createHorizon(scene) {
  const ground = new Mesh(
    new CircleGeometry(28, 64),
    new MeshBasicMaterial({
      color: 0x04080f,
      side: DoubleSide,
      transparent: true,
      opacity: 0.88,
      depthWrite: true,
    }),
  );

  const rim = new Mesh(
    new RingGeometry(26.5, 28.2, 96),
    new MeshBasicMaterial({
      color: 0x80c0e0,
      side: DoubleSide,
      transparent: true,
      opacity: 0.7,
      depthWrite: false,
    }),
  );

  ground.visible = false;
  rim.visible = false;
  // render ground early so stars draw in front when above horizon
  ground.renderOrder = -2;
  rim.renderOrder = -1;
  scene.add(ground);
  scene.add(rim);

  return {
    setVisible(v) {
      ground.visible = v;
      rim.visible = v;
    },
    setTint(hex) {
      rim.material.color.setHex(hex);
    },
    /**
     * @param {import('../bodies/CelestialBody.js').CelestialBody} planet
     * @param {import('three').Vector3} upHint unit up
     */
    update(planet, upHint) {
      if (!ground.visible || !planet) return;
      const up = upHint || new Vector3(0, 1, 0);
      // sit clearly below the eye
      ground.position.copy(planet.position).addScaledVector(up, -0.02);
      rim.position.copy(planet.position).addScaledVector(up, 0.01);
      ground.quaternion.setFromUnitVectors(_z, up);
      rim.quaternion.copy(ground.quaternion);
    },
    dispose() {
      scene.remove(ground);
      scene.remove(rim);
      ground.geometry.dispose();
      ground.material.dispose();
      rim.geometry.dispose();
      rim.material.dispose();
    },
  };
}
